import { CSSObject } from '@emotion/react';
import { AnchorUnderline } from './Anchor.types';
import { hoverStyles } from '../../../theming';

const getHoverStyles = (underline: AnchorUnderline): CSSObject | null => {
    if (underline === 'hover') {
        const hover: CSSObject = {
            textDecoration: underline === 'hover' ? 'underline' : undefined,
            textUnderlineOffset: '0.125em',
        };
        return {
            ...hoverStyles(hover),
        };
    }
    return null;
};

export interface AnchorStylesParams {
    underline: AnchorUnderline;
}

type StyleClasses = 'root';

export function useStyles({ underline }: AnchorStylesParams): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const root: CSSObject = {
        textDecoration: underline === 'always' ? 'underline' : 'none',
        ...getHoverStyles(underline),
    };

    return {
        styles: {
            root,
        },
    };
}
